import WebModel from '../models/WebModel'

const USERSYNC_INIT_INTERVAL = 100
const NEXTROLL_GVL_ID = 130
const MV_UUID_KEY = 'mvUuidKey'

export namespace Usersync {
  // setInterval in the browser returns a number, but here we get a Node Timer instance
  let usersyncTimer

  export const init = (model: WebModel) => {
    if (window.$mediavine.web.usersyncInit) {
      clearInterval(usersyncTimer)
      window.$mediavine.web.usersyncInit({
        ...model,
        alternateMvUuids: [
          {
            get: getNextrollMvUuid,
            set: writeNextrollMvUuid
          }
        ]
      })
    }
    if (!usersyncTimer && !window.$mediavine.web.usersyncInit) {
      usersyncTimer = setInterval(() => init(model), USERSYNC_INIT_INTERVAL)
    }
  }

  export const NextrollLoad = async (model: WebModel) => {
    if (await isNextrollAllowed(model)) {
      const { default: load } = (await import(
        /* webpackChunkName: "nextroll" */ './nextroll'
      )) as any
      load()
    }
  }

  /** flag to let NextrollGetID to bail or not  */
  let nextrollShouldRun: boolean

  /**
   * mobile ios devices, if enabled in model settings,
   * and if vendors list is true for them if applicable
   */
  const isNextrollAllowed = async (model: WebModel): Promise<boolean> => {
    if (
      ((/iPad|iPhone|iPod/i.test(navigator.platform) && !window.MSStream) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      model.nextroll &&
      (await isNextrollTCFOkay())
    ) {
      nextrollShouldRun = true
    } else {
      nextrollShouldRun = false
    }

    return nextrollShouldRun
  }

  const isNextrollTCFOkay = async (): Promise<boolean> => {
    try {
      if (!window.__tcfapi) {
        return true
      }

      const nextrollApproved: Promise<boolean> = new Promise((res, rej) => {
        window.__tcfapi('getTCData', 2, (tcData: any, success: boolean) => {
          success ? res(!!tcData?.vendor?.consents?.[NEXTROLL_GVL_ID]) : rej
        })
      })
      const isOk = await nextrollApproved

      return isOk
    } catch (err) {
      return false
    }
  }

  export const NextrollGetID = () => {
    if (nextrollShouldRun) {
      window.RetrieveAdID &&
        window.RetrieveAdID(
          function(data) {
            // returns data ASAP
            // data is encrypted IDFA string, will be NULL if not available
            handleNextrollData(data)
          },
          function(data) {
            // returns data after server-side sync
            // data is encrypted IDFA string, will be NULL if not available
            handleNextrollData(data)
          },
          {
            PID: '1006'
          }
        )
    }

    return
  }

  const handleNextrollData = (data) => {
    /** xid used to expose nextroll id presence to google tag operations */
    if (data) {
      window.$mediavine.xid = '1'
      window.$mediavine.idfa = data
    } else {
      window.$mediavine.xid = '0'
    }
  }

  const getNextrollMvUuid = (): void => {
    if (nextrollShouldRun) {
      const NextrollData = NextrollGetData()
      if (NextrollData.value) {
        return JSON.parse(NextrollData.value)
      }
    }
  }

  const NextrollGetData = (): Partial<NextrollDataStore> => {
    return (
      (window.dca0 &&
        window.dca0.getData &&
        window.dca0.getData(MV_UUID_KEY, null)) ||
      {}
    )
  }

  const writeNextrollMvUuid = (token: IMVToken): void => {
    if (nextrollShouldRun) {
      window.dca0 &&
        window.dca0.setData &&
        window.dca0.setData(
          MV_UUID_KEY,
          JSON.stringify(token),
          null,
          (itWorked: boolean) => {}
        )
    }
  }
}
